/**
 * A place on a D2C site that shows content the rental company edits in the ERP.
 * Each slot has one value shape; see `classes/d2c-site-content/value`.
 */
export var D2CSiteContentSlot;
(function (D2CSiteContentSlot) {
    // Footer business details required on an online store.
    D2CSiteContentSlot["BUSINESS_PROFILE"] = "profile.business";
    // Customer-service phone and hours, messenger and social links.
    D2CSiteContentSlot["CONTACT_PROFILE"] = "profile.contact";
    // The large images at the top of the home page.
    D2CSiteContentSlot["HOME_HERO"] = "home.hero";
    // Image banners further down the home page.
    D2CSiteContentSlot["HOME_BANNERS"] = "home.banners";
    // The popup shown when the home page opens.
    D2CSiteContentSlot["HOME_POPUP"] = "home.popup";
})(D2CSiteContentSlot || (D2CSiteContentSlot = {}));
// Slots whose value is a list of image items (D2CSiteImageList).
export const D2C_SITE_IMAGE_LIST_SLOTS = [
    D2CSiteContentSlot.HOME_HERO,
    D2CSiteContentSlot.HOME_BANNERS,
    D2CSiteContentSlot.HOME_POPUP,
];
